import { appstr } from "@coreapp/utils/appstr";
import { DialogContent, Icon, Text } from "@theorgchartdev/storybook";

const BrandSetupEnd = () => {
  return (
    <DialogContent customContentClass="oc-brand-setup-content oc-brand-setup-end-tab">
      <Icon name="circle-check" size="xxlarge" color="success" />
      <Text size="large" modifier="medium">
        {appstr("You're all set!")}
      </Text>
      <Text size="medium">{appstr("Your brand is applied.")}</Text>
    </DialogContent>
  );
};

export default BrandSetupEnd;
